import { render } from "./IndexList.vue?vue&type=template&id=a8709efa&ts=true"
import script from "./IndexList.vue?vue&type=script&lang=ts"
export * from "./IndexList.vue?vue&type=script&lang=ts"

import "./IndexList.vue?vue&type=style&index=0&id=a8709efa&lang=scss"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__